import React from 'react';
import DataTable from '../../../ShearCompo/DataTable/DataTable';
import Summary from '../../../ShearCompo/Summary/Summary';
import { Icon } from '@material-ui/core';
import { useState } from 'react';
import ModalLayout from '../../../ShearCompo/ModalLayout/ModalLayout';
import { ManageGroupEditDetails, ManageGroupFrom } from '../../../AllForms/AdminFrom/ManageGroupFrom';
import { Form } from 'react-bootstrap';


const ManageGroup = () => {

    const groupFakeData = [
        {
            id: '#546651',
            name: 'Support Group',
            description: 'This is a support group',
            creationDate: '4:44AM 17 August, 2021',
        },
        {
            id: '#546652',
            name: 'Ticket Group',
            description: 'This is a ticket group',
            creationDate: '4:44AM 17 August, 2021',
        },
    ]
    const tableHeading = ['Group ID', 'Group Name', 'Group Description', 'Creation Date', 'Action']
    const GroupSummaryData = [
        {
            name: "Total Group",
            price: "541 Users",
            img: 'https://i.ibb.co/kgRPWkD/Total-users.png'
        },
        {
            name: "This Year",
            price: "541 Users",
            img: 'https://i.ibb.co/bgJpSVj/This-Year.png'
        },
        {
            name: "This Month",
            price: "41 Users",
            img: 'https://i.ibb.co/5sf3jNQ/This-Months.png'
        },
        {
            name: "This Week",
            price: "5 Users",
            img: 'https://i.ibb.co/HgjVJbz/This-Week.png'
        },
    ];
    const [lgShow, setLgShow] = useState(false)
    const handleClose = () => {
        setLgShow(false);
        setEditDetailsF(false);
    }
    const [editDetailsF, setEditDetailsF] = useState(false);
    // const [Delete, setDelete] = useState(false);
    const [singleGroupData, setSingleGroupData] = useState({});

    let handleShow = () => setLgShow(true);
    //handleEdit
    const handleEdit = (e) => {
        setEditDetailsF(true);
        const getUserById = groupFakeData.find(data => data.id === e);
        setSingleGroupData(getUserById);
    }
    //handleDelete
    const handleDelete = (e) => {
        // setDelete(true);
        const getUserById = groupFakeData.find(data => data.id === e);
        setSingleGroupData(getUserById);
    }

    //get dynamic date for group creation 
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0');
    let yyyy = today.getFullYear();
    today = mm + '/' + dd + '/' + yyyy;


    return (

        <div className="w-100 overflow-hidden">
            <>
                <div className="row pt-4">
                    <Summary summaryArrData={GroupSummaryData} summaryTitle="Group Summary" />
                </div>
                <div className="adminBtn d-flex justify-content-between">
                    <div className="d-flex csvPdfParent">
                        <div className="d-flex align-items-center singleBtn MainLightGreen mx-0">
                            <Icon className="MainLightGreen">download</Icon>
                            <span>Download CSV</span>
                        </div>&nbsp;&nbsp;&nbsp;
                        <div className="d-flex align-items-center singleBtn MainLightGreen mx-0">
                            <Icon className="MainLightGreen">download</Icon>
                            <span>Download PDF</span>
                        </div>
                    </div>
                    <div className=" singleBtn MAIN_BG_DARK_GREEN text-white mx-0">
                        <div onClick={handleShow} className="d-flex align-items-center">
                            <Icon className="me-3">add</Icon>
                            <span >Add Group</span>
                        </div>
                    </div>
                </div>
                {/* manage group from */}
                <ModalLayout
                    ModalTitle="Add Group"
                    handleClose={handleClose}
                    Show={lgShow}
                    modalBody={<ManageGroupFrom />}
                />
            </>

            {/* manage group data table */}
            <DataTable
                tableInputFrom={
                    <Form className="col-lg-5 p-0 tableSearch topInputFrom" id="topInputFrom1">
                        <div className="form-bd shadow-sm rounded">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <button id="button-addon3" type="submit" className="btn btn-link text-muted d-flex align-items-center">
                                        <Icon className="mt-1">search</Icon>
                                    </button>
                                </div>
                                <input type="search" placeholder="Search manage group" className=" topSearchInput form-control rounded " />
                            </div>
                        </div>
                    </Form>
                }
                tableHeading={tableHeading} tableBodyData={
                    groupFakeData?.map((tableData, index) =>
                        <tr key={index} className="text-center">
                            <th scope="row">{tableData.id}</th>
                            <td>{tableData.name}</td>
                            <td>{tableData.description}</td>
                            <td> {tableData.creationDate} </td>
                            <td className="d-flex justify-content-center align-items-center">
                                <span className="cursorPointer MainDarkGreen" onClick={() => handleEdit(tableData.id)}>
                                    <i className="fas fa-pencil-alt"></i>&nbsp;Edit
                                </span>
                                &nbsp;&nbsp;&nbsp;
                                <span className="cursorPointer LIGHT_RED" onClick={() => handleDelete(tableData.id)}>
                                    <i className="far fa-trash-alt"></i>&nbsp;Delete
                                </span>
                            </td>
                        </tr>
                    )
                } />


            <ModalLayout
                // manage groupe edit from
                ModalTitle={`${'Group Id-' + singleGroupData.id}`}
                Show={editDetailsF}
                handleClose={handleClose}
                modalBody={<ManageGroupEditDetails userDetails={singleGroupData} />}
            />

        </div>
    );
};

export default ManageGroup;

